export enum EventExecutorTypeEnum {
  SYSTEM = 'SYSTEM',
  MANAGER = 'MANAGER',
  EXECUTOR = 'EXECUTOR', // This represents the user who initiates the action
}
